import { onValue, off } from "firebase/database";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import Mensagens, {
    MensagensPlaceHolder,
} from "../../../../../Components/CardsPages/Mensagens";
import { useAtedimento } from "../../../../../Context/Atendimento";
import { useUserInfor } from "../../../../../Context/User";
import { IMensagem } from "../../../../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";
import { getConversaRef } from "../../../../../Services/Config/ConfigFirebase";

interface IConversaMensagensProps {
    getMensagensContaChatHistorico: (
        nrTelefone: string
    ) => Promise<Array<IMensagem>>;
}

export default function ConversaMensagens(props: IConversaMensagensProps) {
    const { chatAberto, equipe } = useAtedimento().HELP_DESK;
    const { OrgInfor } = useUserInfor();

    const [mensagens, setMensagens] = useState<Array<IMensagem>>([]);
    const [lstMensagensHistorico, setLstMensagensHistorico] = useState<
        Array<IMensagem>
    >([]);
    const [showAntigas, setShowAntigas] = useState(false);

    // ref que guarda o valor do tamanho da div para fazer scroll imperceptível ao abrir mensagens antigas
    const scrollHeightRef = useRef(0);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setShowAntigas(false);
        if (chatAberto && equipe.NR_TELEFONE) {
            setMensagens([]);
            setLstMensagensHistorico([]);
            const mensagensRef = getConversaRef(
                OrgInfor.ID_ORGANIZACAO,
                equipe.NR_TELEFONE,
                chatAberto.NumeroCliente
            );
            onValue(mensagensRef, (snap) => {
                const mensagensArray: Array<IMensagem> = [];
                snap.forEach((childSnap) => {
                    mensagensArray.push(childSnap.val());
                });
                setMensagens(mensagensArray);
            });
        } else {
            setMensagens([]);
            setLstMensagensHistorico([]);
        }

        return function cleanup() {
            if (chatAberto && equipe.NR_TELEFONE) {
                off(
                    getConversaRef(
                        OrgInfor.ID_ORGANIZACAO,
                        equipe.NR_TELEFONE,
                        chatAberto.NumeroCliente
                    )
                );
            }
        };
    }, [OrgInfor.ID_ORGANIZACAO, chatAberto, equipe.NR_TELEFONE]);

    useEffect(() => {
        const scrollDiv = document.getElementById("mensagens-div");
        if (scrollDiv) {
            scrollDiv.scrollTo({
                top: scrollDiv.scrollHeight,
                behavior: "smooth",
            });
        }
    }, [mensagens]);

    useLayoutEffect(() => {
        const scrollDiv = document.getElementById("mensagens-div");
        if (lstMensagensHistorico.length && !loading) {
            if (scrollDiv) {
                scrollDiv.scrollTo({
                    top: scrollDiv.scrollHeight - scrollHeightRef.current,
                    behavior: "auto",
                });
            }
        }
    }, [lstMensagensHistorico, loading]);

    return (
        <div className="card-body pb-0 customScroll" id="mensagens-div">
            <div>
                {loading ? (
                    <MensagensPlaceHolder />
                ) : chatAberto && showAntigas ? (
                    <Mensagens mensagens={lstMensagensHistorico} />
                ) : (
                    chatAberto &&
                    !showAntigas &&
                    mensagens.length > 0 && (
                        <div className="w-100 d-flex flex-column justify-content-center align-items-center mb-10">
                            <button
                                type="button"
                                className="btn btn-primary btn-md font-weight-bold py-2 px-6"
                                onClick={() => {
                                    setShowAntigas(true);
                                    scrollHeightRef.current =
                                        document.getElementById("mensagens-div")
                                            ?.scrollHeight ?? 0;
                                    const numeroCliente =
                                        chatAberto.NumeroCliente;
                                    setLoading(true);
                                    props
                                        .getMensagensContaChatHistorico(
                                            numeroCliente
                                        )
                                        .then((res) => {
                                            // garante que ainda é a mesma conversa aberta
                                            if (
                                                chatAberto.NumeroCliente ===
                                                numeroCliente
                                            )
                                                setLstMensagensHistorico(res);
                                        })
                                        .finally(() => {
                                            setLoading(false);
                                        });
                                }}
                            >
                                Carregar mensagens antigas
                            </button>
                            <div className="text-muted text-center">
                                Essas são as mensagens deste atendimento, mas
                                você ainda pode ver as mensagens anteriores
                                deste contato, se houver alguma
                            </div>
                        </div>
                    )
                )}
                <Mensagens mensagens={mensagens} />
            </div>
        </div>
    );
}
